import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import { Router } from '@angular/router';
import * as Constants from '../models/Constants';
import { Observable, catchError, forkJoin, map, of, switchMap, timer } from 'rxjs';
import { Global } from '../global/globalApi';
import { LogOutDTO, SessionDetailsDTO } from '../models/LogOutDTO';
import { LoginDTO } from '../models/LoginDTO';
import { NewAgentApiService } from './new-agent-api.service';
import { GenesysCloudService } from './genesys-cloud.service';
import { CallCustomerAttributes } from '../models/customer.model';
import { AwsSqsService } from './aws-sqs.service';
import { LogService } from './log.service';
import buildInfo from '../../../src/build';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  // url = "https://10.41.131.46/"; //Nithya IP
  // url = "http://100.106.116.195:9091"; // Dinesh IP
  //url = 'https://10.41.151.63:9091/'; //Arun IP
  //url - 'https://10.41.158.235:9091/'; //Pooja IP
  url = 'https://cct-dv-int.dcsa.aws.alight.com/';
  fileName: string = 'apiService';
  constructor(
    private newAgentApiService: NewAgentApiService,
    public rootScope: RootScopeService,
    public awsSQSService: AwsSqsService,
    private router: Router,
    private http: HttpClient,
    public genesysCloudService: GenesysCloudService,
    private logService: LogService
  ) { }

  /* istanbul ignore next */
  logOut(timeout?): Observable<any> {
    let userId: any = localStorage.getItem('userId');
    let reqBody = new LogOutDTO();
    let region =  sessionStorage.getItem('pref_region');
    reqBody.geneSysUserId = timeout?'':userId;
    reqBody.emailId = this.rootScope.emailId;
    if (region)
      reqBody.region = region;
    reqBody.sessionDetails = new SessionDetailsDTO();
    // console.log('this.rootScope.sessionId', this.rootScope.sessionId);
    reqBody.sessionDetails['sessionId'] = this.rootScope.sessionId;
    return this.http.delete(Global.domainUrl + Global.LOG_OFF_API, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      responseType: 'text',
      body: reqBody,
    });
  }

  /**
   * 
   * @returns 
   */
  genesysLogoutObs(): Observable<any> {
    let geneSysUserId: any = localStorage.getItem('userId');
    let reqBody = new LogOutDTO();
    let region = sessionStorage.getItem('selectedRegion');
    reqBody.geneSysUserId = geneSysUserId;
    reqBody.emailId = this.rootScope.emailId;
    if (region)
      reqBody.region = region;

    let url = Global.domainUrl + Global.GENESYS_LOGOUT
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });

  }

  genesysLogout(invalid?:boolean) {
    if (invalid) {
      this.rootScope.endRegistrationMsg=Constants.ALIS_CP_ENV_MISMATCH_MSG;
      this.endALISRegistration();
      return;
    }
    else{
    this.rootScope.alisRegistrationLoader = true;
    this.genesysLogoutObs().subscribe({
      next: (res: any) => {
        /* istanbul ignore next */
        if (res) {
        this.endALISRegistration();
        }

      },
      error: (error) => {
        /* istanbul ignore next */
        if (error) {
          console.log('Error while logging out from genesys');
          this.rootScope.alisRegistrationLoader = false;
          this.rootScope.ALISRegistrationCardError = true;
          this.rootScope.ALISRegistrationCardSuccess = false;
          this.rootScope.ALISRegistrationSuccessChangeOrg = false;
          this.rootScope.indicatorClass = 'gray';
          this.genesysCloudService.unsubscribeALISNotifications();
          sessionStorage.setItem('connectToGenesys', 'false');
          this.rootScope.setIsGensysLoggedIn(false);
        }
      }
    })
  }
}


  endALISRegistration() {
    sessionStorage.setItem('connectToGenesys', 'false');
    this.rootScope.ALISRegistrationCardSuccess = false;
    this.rootScope.alisRegistrationLoader = false;
    this.rootScope.ALISRegistrationSuccessChangeOrg = false;
    this.rootScope.ALISRegistrationCardError = false;
    this.rootScope.setIsGensysLoggedIn(false);
    this.rootScope.indicatorClass = 'gray';
    this.genesysCloudService.unsubscribeALISNotifications();
  }

  /**
   * Below method handles triggering
   * of logff api and handling of api
   * failure or success.
   * If api fails, user needs to prompt alert msg and will NOT be
   * redirected to logoff page and vice versa
   */
  /* istanbul ignore next */
  userLogout(timeout?) {
    this.rootScope.showLoader();
    if(sessionStorage.getItem('connectToGenesys') == 'true'){
      this.genesysCloudService.conversationsApi.getConversationsCalls().then((data) => {
        if (data?.entities?.length) {
          const agentConversations = data.entities?.find(x => x?.participants?.find(y => y?.user?.id == localStorage.getItem('userId') && y?.connectedTime && (!y?.endTime && y.state == Constants.ALIS_Live_Status.connected)));

          if (agentConversations) {
            this.CarePortalLogout(true);
          }
          else {
            this.CarePortalLogout(false);
          }
        }
        else {
          this.CarePortalLogout(false);
        }
    }).catch((err) => {
      this.logService.errorLogs("There was a failure calling getConversations for logout :" + JSON.stringify(err), this.fileName)
     this.CarePortalLogout(false);
    });
    }
    else{
    this.CarePortalLogout(timeout);
    }
   
  }

  /**
   * Logs out the user from the CarePortal application.
   *
   * Initiates the logout process by calling the `logOut` method and handles the response.
   * On successful logout, updates authentication state, clears cache, removes session expiry,
   * and triggers additional logout actions (such as logging out from Genesys Cloud).
   * If the logout fails, displays an error alert and logs the failure.
   * Handles errors by displaying alerts, logging errors, and invoking timeout logic if applicable.
   *
   * @param timeout Optional timeout value to be passed to the logout process.
   */
  CarePortalLogout(timeout?) {
     this.logOut(timeout).subscribe({
      next: (res: any) => {
        /* istanbul ignore next */
        if (res.includes('successfully')) {
          this.rootScope.isErrorToHide = true;
          this.rootScope._isAuthenticated.next(false);
          this.rootScope._isLogout.next(true);
          this.genesysCloudService.logOutALIS(timeout);
          this.rootScope.clearCache();
          this.rootScope.dataBaseSelecterMap={}
          if(sessionStorage.getItem('sessionExpiry')){
            sessionStorage.removeItem('sessionExpiry');
          }
          //  this.router.navigate(['/log-out']);
        } else {
          this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.API_FAILURE_MSG
          );
          this.logService.errorLogs('USER-LOGOUT-ALIS-API-FAILURE:', this.fileName);
        }
        this.rootScope.hideLoader();
      },
      error: (error) => {
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.logService.errorLogs('USER-LOGOUT-ALIS-API-FAILURE:', this.fileName);
        this.rootScope.hideLoader();
        /**Added below Condition for CCR1-7023 */
        if(this.rootScope.appTimeoutSuccess){
          this.appTimeOut();
        }
      },
    });
  }

  /**
   * Below method handle the User Authenticate Service which validate the
   * User Credentials and in case of successful response it give redirect URL and
   * in case failure it give the errors.
   */
  login(reqBody: LoginDTO, isTestUser: boolean): Observable<any> {
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .append('Connection', 'keep-alive')
      .append('version', Constants.apiVersions);

    if (isTestUser) {
      let url = Global.domainUrl + Global.LOAD_TEST_USER_LOGIN + "/" + reqBody['lanId'];
      return this.http.get(url, {
        headers: headers,
      });
    }
    else {
      let url = Global.domainUrl + Global.LOGIN_API;
      return this.http.post(url, reqBody, {
        headers: headers,
      });
    }
  }

  handleMultiSession(createNewSession) {
    this.rootScope.cacheClearGenesysAndTBARegistration(createNewSession);
    if (this.rootScope.isSSODuplicate) {
      this.sessionLogOutAndLoginForSSO(createNewSession);
    } else {
      this.sessionLogoutAndLoginAgain(createNewSession);
    }
  }

  /****
   * Below method triggers backend api
   * which kills existing sessin and create new on
   * click of yes and on no  too backend api
   * gets triggered but createNewSession = false in this case for NON_SSO
   */

  sessionLogoutAndLoginAgain(createNewSession) {
    this.logOutandLoginAgain(createNewSession).subscribe({
      next: (data: any) => {
        // console.log('data', data);
        if (data) this.handleSessionAsPerUserSelection(createNewSession, data);
      },
      error: (error) => {
        // console.log('Error in creating new session', error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.logService.errorLogs(Constants.API_FAILURE_MSG, this.fileName);
      },
    });
  }

  logOutandLoginAgain(createNewSession) {

    let url = Global.domainUrl + Global.HANDLE_MULTI_SESSION;
    let reqBody = {
      emailId: this.rootScope.emailId,
      createNewSession: createNewSession,
    };

    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });

    // return this.http.get(Global.domainUrl + Global.HANDLE_MULTI_SESSION, {
    //   headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    //   params: {
    //     emailId: this.rootScope.emailId,
    //     createNewSession: createNewSession,
    //   },
    // });
  }

  /**
   * Below method gets all the application related configuration needed
   * like aws sqs credentials/genesys etc
   */
  getApplicationConfiguration() {
    // console.log('metjod getApplicationConfiguration called');
    return this.http.get(Global.domainUrl + Global.GET_APP_CONFIG, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  /****
   * Below method hits the backend api which frontend
   * let frontend know its duplicate session or not.
   */
  getInfoAbtDuplicateSession() {
    let url =
      Global.domainUrl + Global.IS_DUPLICATE_SESSION

    let reqBody = {
      emailId: this.rootScope.emailId
    };

    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

 
  /* istanbul ignore next */
  getUserDetails(session?) {
    this.getUserData().subscribe({
      next: (data: any) => {
        // console.log('user data', data);
        this.rootScope.userData = data['data'];
        if (this.rootScope?.userData?.simulationMode) {
          this.rootScope.simulationData.isSimulationAccess = this.rootScope.userData.simulationMode;
        }

        const agentSkills = this.rootScope.userData?.agentSkills;
        /**In CCR1-6835 we check the batch alerts skills in agent skills */
        if (agentSkills?.length) {
          this.rootScope.batchAlertData.isBatchAlertAccess = this.rootScope.checkAgentSkill(Constants.AGENTS_SKILLS.BATCH_ALERTS);
          this.rootScope.isUDPIdSkillForCustomerSearch = this.rootScope.checkAgentSkill(Constants.AGENTS_SKILLS.Search_By_Global_ID);
          this.rootScope.isSkillPresentForWrapUpComment = this.rootScope.checkAgentSkill(Constants.AGENTS_SKILLS.SKILL_WRAP_UP_COMMENT);
        }

        /*In CCR3-1156 We Store the lanId and pref_region in sessionStorage for saving the preference value 
        in database(admin) user_setting table.*/
       this.updateLandId(data?.data?.lanId)
        if (data?.data?.userSettingMap?.ALIS) {
          this.rootScope.preferenceRegion = JSON.parse(
            data?.data?.userSettingMap?.ALIS
          )?.pref_region;
        }
        let clientID = this.rootScope.getObjFromConfigObj(this.rootScope.preferenceRegion + Constants.ALIS_CLIENT_ID);
        if (clientID) {
          this.rootScope.GENESYS_CLOUD_CLIENT_ID = clientID.fieldValue;
          // console.log(Date() + this.rootScope.GENESYS_CLOUD_CLIENT_ID)
          sessionStorage.setItem('ALIS_CLIENT_ID', clientID.fieldValue);
        }
        if (data?.data?.userSettingMap?.LOG) {

          this.rootScope.isLogEnabledUser = JSON.parse(
            data?.data?.userSettingMap?.LOG
          )?.log_type;
          console.log('logTypes======>' + this.rootScope.isLogEnabledUser);

        }
        /**Author @Vamsi Pamidala
         * @isAlisRegistered previouse session alis Registered status base internally login in alis and capturing notifications
         * alis Registered status is false load Research customer accounts in careportal
         * 
         */
        if (this.rootScope.preferenceRegion && data?.data?.isAlisRegistered) {
          sessionStorage.setItem(
            'pref_region',
            this.rootScope.preferenceRegion
          );
          sessionStorage.setItem(
            'selectedRegion',
            this.rootScope.preferenceRegion
          );
          if (session && data?.data?.isAlisRegistered) this.alisRegistration();
        } else if (session && !data?.data?.isAlisRegistered) {
          this.getRestoreAccountDetails();
        } else if (session && !data?.data?.isAlisRegistered) {

        }
        /* End code*/
        if (
          this.rootScope.createNameForUserProfile(
            this.rootScope.userData['firstName'],
            this.rootScope.userData['lastName'],
            this.rootScope.userData['lanId'],
            this.rootScope.userData['browserSessionStartTimestamp'],
            this.rootScope.userData['emailId']
          )
        ) {
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        // console.log('Error in getting user details new session', error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.logService.errorLogs(Constants.API_FAILURE_MSG + JSON.stringify(error), this.fileName);
      },
    });
  }

  updateLandId(lanId){
    this.rootScope.lanId=lanId;
    sessionStorage.setItem("lanId",this.rootScope.lanId);
    localStorage.setItem("lanId",this.rootScope.lanId);
  }

  getUserData() {

    let url = Global.domainUrl + Global.GET_USER_DETAILS; //+ this.rootScope.sessionId;
    let reqBody = { sessionId: this.rootScope.sessionId };
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  sessionLogOutAndLoginForSSO(createNewSession) {
    this.logOutandLoginAgainForSSO(createNewSession).subscribe({
      next: (data: any) => {
        // console.log('data', data);
        if (data) this.handleSessionAsPerUserSelection(createNewSession, data);
      },
      error: (error) => {

        // console.log('Error in creating new session', error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.router.navigate(['/ssoerror']);
        this.logService.errorLogs(Constants.API_FAILURE_MSG + JSON.stringify(error), this.fileName);
      },
    });
  }

  handleSessionAsPerUserSelection(createNewSession, data) {
    // console.log(
    //   'Method handleSessionAsPerUserSelection called ',
    //   createNewSession
    // );
    if (createNewSession) {
      data = data.httpStatusCode == HttpStatusCode.Ok ? data.data : data;
      /****Here previous opened will be redirected to google default home page ***/
      //  data = data.httpStatusCode == HttpStatusCode.Ok ? data.data : data;

      this.rootScope.sessionId = data?.jSessionId;
      this.rootScope.browserSessionStartTimestamp = data["browserSessionStartTimestamp"];
      sessionStorage.setItem('restoreSession', 'false');
    }
    else {
      this.rootScope.sessionId = data.data?.jSessionId;
      this.rootScope.browserSessionStartTimestamp = data?.data["browserSessionStartTimestamp"];
      sessionStorage.setItem('restoreSession', 'true');
      /**** Here new opened tab will be redirected to google default home page ***/
      // window.open('http://www.google.com', '_self');
    }

    this.getUserDetails(!createNewSession);
    sessionStorage.setItem('userSession', this.rootScope.sessionId); localStorage.setItem('userSession', this.rootScope.sessionId);
    sessionStorage.setItem('browserSessionStartTimestamp', this.rootScope.browserSessionStartTimestamp);
    this.rootScope._isAuthenticated.next(true);
    this.rootScope.loadUI = true;
    /* istanbul ignore next */ // start browser time stamp subscribtion and monitor inactiveity in application 
    this.validateTimeStampToken();
    this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
  }

  logOutandLoginAgainForSSO(createNewSession: any) {

    let url = Global.domainUrl + Global.HANDLE_MULTI_SESSION_SSO;

    let reqBody = {
      emailId: this.rootScope.emailId,
      createNewSession: createNewSession,
      oldSessionId: (this.rootScope.oldSessionId || sessionStorage.getItem('userSession') || ""),
      newSessionId: this.rootScope.newSessionId,
    };

    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });

    // return this.http.get(Global.domainUrl + Global.HANDLE_MULTI_SESSION_SSO, {
    //   headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    //   params: {
    //     emailId: this.rootScope.emailId,
    //     createNewSession: createNewSession,
    //     oldSessionId: (this.rootScope.oldSessionId || sessionStorage.getItem('userSession') || ""),
    //     newSessionId: this.rootScope.newSessionId,
    //   },
    // });
  }

  /**
   * Below is a common method to communicate to backend for this api
   * @param keyName
   * @returns
   */

  getDataByCommonKeyValueApi(keyName) {
    let url = `${Global.domainUrl + Global.dashboardApi.ValidValuesApi
      }?validFieldKey=${keyName}`;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  saveDatabaseSelecter(reqBody) {
    let url = `${Global.domainUrl + Global.UPDATE_USER_DB_SELECTER}`;
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  
  getDataByValidValuesApi() {
    const fieldKeys = [
      Constants.CUSTOMER_TYPE,
      Constants.CHANNEL_LIST,
      Constants.THIRD_PARTY_LIST,
      Constants.UNKNOWN_CALLER_TYPE_LIST,
      Constants.PRIMARY_LANGUAGE,
      Constants.PREFERRED_LOCALE,
      Constants.INTERACTION_HISTORY_CONF,
      Constants.CIM_DATA_ATTRIBUTE_MAPPING,
      Constants.OTC_LENGTH_CONFIG,
      Constants.AUTHORIZED_ROLETYPE,
      Constants.PIN_APP,
      Constants.ALIS_REGION,
      Constants.VAL_APP,
      Constants.BATCH_ALERT,
      Constants.PIN_RESET_MSGS,
      Constants.TBAGUI_LIFECYCLE,
      Constants.SCREEN_POP_DESKTOP_INDICATOR,
      Constants.PLAN_TYPES_FOR_HEALTH_CARD,
      Constants.KC_PORTAL_LIST,
      Constants.ALIS_ORG,
      Constants.HEALTH_CARD_APPROVED_EXCEPTIONS,
      Constants.ID_MAPPING_PLATFORM_TYPE,
      Constants.ROLE_TYPE_DETAILS,
      Constants.INTERACTION_TYPE,
      Constants.INTERACTION_MODES,
      Constants.INTERACTION_MODE_SUBTYPE,
      Constants.SIMULATION.SIMULATION_TYPE,
      Constants.MYFRSLINK
    ].join(Constants.VALID_VALUES_API_SEPERATOR);

    const url = `${Global.domainUrl}${Global.dashboardApi.validValuesAPINew}`;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        fieldKeys,
      },
    });
  }

  /**
   * @author : Amarjeet Kumar
   * calling 3 custome accounr apis togather in sequence
   * @param : 'customer-type','CHANNEL-LIST' & 'DOMAIN-LIST'
   * API 1- customer-type list on main customer account page
   * API 2- channel list for IH filter popup
   * API 3- Third Party dropdown list list for wrapup page
   */
  // customerAccountApis() {


  //   // this.getDataByValidValuesApi
  //   let customerType = this.getDataByCommonKeyValueApi(Constants.CUSTOMER_TYPE).pipe(catchError((err) => {
  //     this.rootScope.customerTypeAPIFailure = true;
  //     return of({ isError: true, error: err });
  //   })
  //   );
  //   let channelList = this.getDataByCommonKeyValueApi(Constants.CHANNEL_LIST).pipe(catchError((err) => of({ isError: true, error: err })));
  //   let thirdPartyList = this.getDataByCommonKeyValueApi(Constants.THIRD_PARTY_LIST).pipe(catchError((err) => of({ isError: true, error: err })));
  //   let unknownCallerType = this.getDataByCommonKeyValueApi(Constants.UNKNOWN_CALLER_TYPE_LIST).pipe(catchError((err) => {
  //     this.rootScope.unknownCallerTypeAPIFailure = true;
  //     return of({ isError: true, error: err });
  //   }));
  //   let primaryLanguage = this.getDataByCommonKeyValueApi(Constants.PRIMARY_LANGUAGE).pipe(catchError((err) => of({ isError: true, error: err })));
  //   let preferredLocale = this.getDataByCommonKeyValueApi(Constants.PREFERRED_LOCALE).pipe(catchError((err) => of({ isError: true, error: err })));

  //   forkJoin([customerType, channelList, thirdPartyList, unknownCallerType, primaryLanguage, preferredLocale]).subscribe((res: any) => {
  //     /* istanbul ignore next */
  //     if (res) {
  //       this.rootScope.customerTypeData = res[0]?.data?.body;

  //       let IHChannelList = res[1]?.data?.body;
  //       let unknownCallerTypeList = res[3]?.data?.body;
  //       this.rootScope.thirdPartyList = res[2]?.data?.body;
  //       this.rootScope.primaryLanguage = res[4]?.data?.body;
  //       this.rootScope.preferredLocale = res[5]?.data?.body;

  //       if (IHChannelList) {
  //         IHChannelList.sort((a, b) => parseFloat(a.sequence) - parseFloat(b.sequence));
  //         this.rootScope.IHChannelList = IHChannelList;
  //       }
  //       if (unknownCallerTypeList) {
  //         unknownCallerTypeList.sort((a, b) => a.fieldValueDescription.localeCompare(b.fieldValueDescription));
  //         this.rootScope.unknownCallerTypeList = unknownCallerTypeList;
  //       }
  //     }
  //   });
  //   // this.getIHConfigData();

  //   // this.getCIM_DATAConfig();//CCR3-4520 get cimdata configration
  //   //this.getDuelDeskTopIndicator();

  // }

  getIHDataForBriefView() {
    let url = Global.domainUrl + Global.GET_IH_BRIEF_DATA;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        searchId: this.rootScope.activeCustTab.id
      }
    });
  }

  getIHDataForListView() {
    let url = Global.domainUrl + Global.GET_IH_LIST_DATA;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        searchId: this.rootScope.activeCustTab.id
      }
    });
  }


  /* @author :vamsi pamidala
  Validate the timestamp and avoid duplicate/multisession in careportal 
  every 5 sec silent api request will send to api to verify the timestamp 
if its sucess it will print in console other wise it will route to session expiry page 
   */
  /* istanbul ignore next */
  validateTimeStampToken() {
    this.rootScope.browserSubscription = timer(0, this.rootScope.CCTConfigs.ACTIVE_SESSION_EVALUATE_INTERVAL).pipe(
      switchMap(() => 
        this.newAgentApiService.getApi(Global.isSessionActive, { browerStartTimeStamp: this.rootScope.browserSessionStartTimestamp || sessionStorage.getItem('browserSessionStartTimestamp') || new Date().toLocaleDateString() }, 'false', false))
    ).subscribe({
      next: (res) => {
        if (res && res.responseType == 'SUCCESS') {
          console.log('Session is active:', res);
        } else {
          if (this.rootScope.isAuthenticate) {
          console.log('Session is inactive or failed:', res);
          this.handleSessionExpiry();
          }
        }
      },
      error: (error) => {
          console.log(error);
          this.handleSessionExpiry();
          this.logService.errorLogs(Constants.API_FAILURE_MSG + JSON.stringify(error), this.fileName);
        }
    }
    );
  }

  /* Helper method to handle session expiry */
  private handleSessionExpiry() {
    this.rootScope.sessionExpiry = true;
    this.appTimeOut();
    sessionStorage.setItem('sessionExpiry', "true");
  }



  /**Author @Vamsi Pamidala
   * get all previous session details when user refresh/duplicate/crashing the applicaion 
   * User relaunch the application user can choose open new session and Restore account
   * User click on Restore button get all Customer account (Research/live call/chat/additional account)
   * if api fails it will show message in console and snackbar
   */
  getRestoreAccountDetails() {
    this.newAgentApiService.getApi(Global.customerApi.getRestoreAccountDetails, null, 'false', false)
      .subscribe({
        next: (res) => {
          /* istanbul ignore next */
          if (res && res.data != Constants.errorObj.restoreError && res.data?.length) {

            let additionalAccounts = res.data.filter(x => x.cusTab?.additionalAccount);
            this.rootScope.restoreSession = this.rootScope.getValueFromSessiondb('restoreSession', false);
            // set sequence both additionalAccounts and primary 
            if (this.rootScope.restoreSession && additionalAccounts?.length > 0) {
              additionalAccounts.forEach(additionalAcc => {
                if (additionalAcc.conversationId) {
                  let accountIndex = res.data.findIndex(x => x.globalIdentifierId == additionalAcc.globalIdentifierId && x.cusTab.conversationId == additionalAcc.cusTab.conversationId);
                  let parentAccIndex = res.data.findIndex(x => x.globalIdentifierId == additionalAcc?.cusTab?.parentId && x.cusTab.conversationId == additionalAcc?.cusTab.conversationId);
                  res.data.splice(accountIndex, 1);
                  res.data.splice(parentAccIndex + 1, 0, additionalAcc);
                }
              });
            }
            setTimeout(() => {
              res.data.forEach((element, index) => {
                if (element.cusTab.id) {
                  element.cusTab.restoreTab = true;
                  this.rootScope.customerTabs.push(element.cusTab);
                  this.genesysCloudService.getRestoreCompAccDetails(element.cusTab);
                }
                if (index + 1 == res.data?.length && this.rootScope.isGenesysLoggedIn) {
                  this.sendReqToGetLiveInteraction(true);
                }
              });
            }, additionalAccounts?.length > 0 ? 100 : 0);


            console.log(res);
          } else this.sendReqToGetLiveInteraction();
          //to handle organization validation in restore flow
          if(this.rootScope.isGenesysLoggedIn)
          this.genesysCloudService.getOrganizationsMe();
        },
        error: (error) => {
          console.log(error); this.sendReqToGetLiveInteraction(); this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.AlertMsg.error500
          );
          //to handle organization validation in restore flow
          if(this.rootScope.isGenesysLoggedIn)
            this.genesysCloudService.getOrganizationsMe();
          this.logService.errorLogs("GET-RESTORE-ACCOUNT-FAILURE" + JSON.stringify(error), this.fileName);
        }
      })
  }

  sendReqToGetLiveInteraction(openAccount?) {
    if (this.rootScope.isGenesysLoggedIn || this.rootScope.getValueFromSessiondb('connectToGenesys', false)) {
      this.genesysCloudService.saveAllQueueFromGen();
      /* istanbul ignore next */
      if (openAccount && this.rootScope.restoreSession) {
        let liveCallAccount = this.rootScope.customerTabs.filter(x => x.conversationId && x.conversationId != "NA" && x.channel == Constants.IH_CALL && !x.additionalAccount);
        let liveChatAccount = this.rootScope.customerTabs.filter(x => x.conversationId && x.conversationId != "NA" && x.channel == Constants.IH_CHAT && !x.additionalAccount);

        if (liveCallAccount?.length > 0) {
          this.rootScope.isLiveCall = true;

        } else if (liveChatAccount?.length > 0) {
          this.rootScope.isLiveChat = true;
          // For CCR3-3830
          if (this.rootScope.checkLiveChatAccount()) {
            this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
          }
        }
        // find the live call/chat account update local varibale (islivecall,islivechat)
        this.genesysCloudService.restoreLiveData = liveChatAccount.concat(liveCallAccount);
        if (this.genesysCloudService.restoreLiveData?.length > 0) {
          this.genesysCloudService.restoreLiveData?.forEach(element => {
            if (element.channel == Constants.IH_CALL) {
              this.genesysCloudService.checkConversationsCall(element.conversationId, element);//check live call status based on conversation id
            }
            else if (element.channel == Constants.IH_CHAT) {//CCR3-8214
              if (element.webMessage) this.genesysCloudService.getWebMessageData(element.conversationId, element);
              else
                this.genesysCloudService.checkConversationsChat(element.conversationId, element);//check live chat status based on conversation id
            }
          });
        }

      }

      setTimeout(() => {
        this.genesysCloudService.getLiveInteractions();
      }, 2000);
    }
  }

  alisRegistration() {
    if (!this.rootScope.getValueFromSessiondb('connectToGenesys', false) && this.rootScope.appConfigObj && this.rootScope.preferenceRegion) {
      let fieldName = this.rootScope.preferenceRegion + '_AUTH_URL';
      let regionObj = this.rootScope.getObjFromConfigObj(fieldName);
      this.genesysCloudService?._environment.next(regionObj?.fieldValue);
      this.rootScope._ALISSelectedRegionObj.subscribe((res) => {
        sessionStorage.setItem('ALISRegisteredRegionObj', JSON.stringify(res));
      });
      this.genesysCloudService.sendMessage(true);
      sessionStorage.setItem('connectToGenesys', 'true'); sessionStorage.setItem('ALISRegistration', 'true');
    }
  }

  /**
   * @author :Pooja 
   * @returns 
   */

  getRepeatAlertMsg() {

    let url = Global.domainUrl + Global.GET_REPEAT_ALERT;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        contactId: this.rootScope.activeCustTab.id,
        callerType: this.rootScope.activeCustTab.defaultRole
      }
    });
  }

  /**
 * Retrieves customer types data from a common key-value API.
 * This method updates the `customerTypeData` property in the root scope
 * with the fetched data and sets `customerTypeAPIFailure` to true
 * in case of an error.
 */
  getCustomerTypesAPI() {
    this.rootScope.customerTypeAPIFailure = false;
    this.getDataByCommonKeyValueApi(Constants.CUSTOMER_TYPE).subscribe({
      next: (res: any) => {
        this.rootScope.customerTypeData = res.data?.body;
      },
      error: (err) => {
        this.rootScope.customerTypeAPIFailure = true;
        this.logService.errorLogs("GET-CUSTOMER-TYPE-API-FAILURE" + JSON.stringify(err), this.fileName);
      }

    })
  }

  getAlertTypes(clientId) {
    let url = Global.domainUrl + Global.ALERTS_TEMPLATES;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions,this.rootScope.activeCustTab.customerSessionId),  
      params: {
        clientId: clientId
      }
    });
  }

  getCustomerPanelId() {
    const url = Global.domainUrl + Global.customerApi.panelId + `?panelName=alert`;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
    }).subscribe({
          next: () => { },
          error: () => { }
        });;
  }

  creatAlerts(reqBody) {
    let url = Global.domainUrl + Global.CREATE_ALERTS;
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        panelName: "alert"
      }
    });

  }

  /** 
  * getAllAlerts() -- calling API to get all alerts list.
  * @author :Amarjeet Kumar
  */
  getAlertList() {
    let url = Global.domainUrl + Global.CREATE_ALERTS;
    const defaultRole = this.rootScope.activeCustTab.defaultRole ? this.rootScope.activeCustTab.defaultRole : 'Employee';
    const roleType = Constants.EXCLUDE_ROLE_TYPE.includes(defaultRole) ? 'Employee' : defaultRole;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        roleType: roleType
      }
    });
  }

  saveEditAlertData(runtimeAlertId, reqBody) {
    let url = Global.domainUrl + Global.SAVE_EDIT_ALERTS + runtimeAlertId;
    return this.http.put(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  deleteAlert(runtimeAlertId) {
    let url = Global.domainUrl + Global.SAVE_EDIT_ALERTS + runtimeAlertId;
    return this.http.delete(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  getDomainList() {
    let url = Global.domainUrl + Global.GET_TOPIC_LIST;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        clientId: this.rootScope.activeCustTab.clientId
      }
    });
  }

  getFilterDomainList() {
    let url = Global.domainUrl + Global.GET_TOPIC_LIST;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  setAccountSecurityDt(model, body) {

    let accountDt = this.rootScope.activeCustTab;
    let ParticipantId = (accountDt.customerParticipantId != 'NA' && accountDt.customerParticipantId ? accountDt.customerParticipantId : this.rootScope.getParticipantId());
    this.genesysCloudService.updateSecurityLevelInGEN(accountDt.conversationId, ParticipantId, body, model);

  }


  /* istanbul ignore next */
  appTimeOut() {
    console.log('log-out App');
    this.rootScope._isAuthenticated.next(false);
    this.rootScope.browserSubscription?.unsubscribe();
    /* istanbul ignore next */
    this.rootScope._isLogout.next(true);
    this.genesysCloudService.logOutALIS(true);
    sessionStorage.clear();
    this.rootScope.dataBaseSelecterMap={};

  }

  /**
   * Below method handles dynmic timer seconds running a counter down secs and
   * stop timer session once it reaches zero sec
   * 
   */
  appSessionTimer() {
    setTimeout(() => {
      if (!this.rootScope.loadUI) {
        this.appTimeOut();
      }
    }, this.rootScope.CCTConfigs.APP_SESSION_TIMEOUT * 1000);
  }

  /**
   * Below method is used to fetch Document Data
   * @param paramsObject 
   * @returns 
   */
  getDataToViewDocument(paramsObject) {
    let url = Global.domainUrl + Global.GET_DOCUMENT_CONTENT;

    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: paramsObject,
      responseType: 'arraybuffer'
    });
  }

  /** 
  * getIHMessageData(paramsObject) -- Calling API to get IH message.
  * @author :Amarjeet Kumar
  */
  getIHMessageData(reqBody) {
    let url = Global.domainUrl + Global.GET_MESSAGE_CONTENT;
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      responseType: 'arraybuffer'
    });
  }


  getAutoLaunchConfigData(clientID) {
    let params = { clientId: clientID }
    let url = Global.domainUrl + Global.customerApi.autoLaunchAPI;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: params
    });
  }


  /**
   * Below method is used to fetch agent InteractionData.
   * @param paramsObject 
   * @returns 
   */
  getAgentInteractionData(paramsObject?: any) {
    let url = Global.domainUrl + Global.GET_AGENT_INTERACTION_DATA;

    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: paramsObject
    });
  }

  globalIconIdUpdate(id) {
    let favIcon = document.getElementById(Constants.applicationId);
    this.rootScope.globalIconId = id?.toString();
    favIcon?.setAttribute('id', Constants.applicationId + this.rootScope.globalIconId);
    this.globalIconUpdate(false);
  }

  globalIconUpdate(warning?) {
    let favIcon = document.getElementById(Constants.applicationId + this.rootScope.globalIconId);

    if (warning)
      favIcon?.setAttribute('href', './../../assets/images/warning.png');
    else favIcon?.setAttribute('href', `./../../assets/images/favicon.png?v=${Date.now()}`);
  }

  /**
   * Below method fetch the unknown caller type list from the backend.
   */
  getUnknownCallerTypes() {
    this.rootScope.unknownCallerTypeAPIFailure = false;
    this.getDataByCommonKeyValueApi(Constants.UNKNOWN_CALLER_TYPE_LIST).subscribe({
      next: (res: any) => {
        let unknownCallerTypeList = res?.data?.body;

        if (unknownCallerTypeList) {
          unknownCallerTypeList.sort((a, b) => a.fieldValueDescription.localeCompare(b.fieldValueDescription));
          this.rootScope.unknownCallerTypeList = unknownCallerTypeList;
        }
      },
      error: (err) => {
        this.rootScope.unknownCallerTypeAPIFailure = true;
        this.logService.errorLogs("GET-UNKNOWN-CALLER-TYPE-API-FAILURE" + JSON.stringify(err), this.fileName);
      }
    })
  }

  /**Below method return the Observable for Interaction History List view Data for a Date Range Period  */
  getIHDataForListViewForDateRange(fromDate: string, toDate: string) {
    let url = Global.domainUrl + Global.GET_IH_LIST_DATA;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        searchId: this.rootScope.activeCustTab.id,
        fromDate: fromDate,
        toDate: toDate
      }
    });
  }

  /**
  * Below method fetch the Interaction History Config from the backend.
  */
  // getIHConfigData() {
  //   this.getDataByCommonKeyValueApi(Constants.INTERACTION_HISTORY_CONF).subscribe({
  //     next: (res: any) => {
  //       let interactionHistoryConfig = res?.data?.body;

  //       if (interactionHistoryConfig) {
  //         let MAX_IH_RECORDS_LEGACYDATA_Obj = this.rootScope.getObjFromConfigObjValidValues(Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_IH_RECORDS_LEGACYDATA, interactionHistoryConfig);
  //         let MAX_DAYS_FOR_LEGACYDATA_Obj = this.rootScope.getObjFromConfigObjValidValues(Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_DAYS_FOR_LEGACYDATA, interactionHistoryConfig);

  //         this.rootScope.interactionHistoryConfig.MAX_IH_RECORDS_LEGACYDATA = MAX_IH_RECORDS_LEGACYDATA_Obj?.fieldValueDescription ? MAX_IH_RECORDS_LEGACYDATA_Obj?.fieldValueDescription : Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_IH_RECORDS_LEGACYDATA_VALUE;
  //         this.rootScope.interactionHistoryConfig.MAX_DAYS_FOR_LEGACYDATA = MAX_DAYS_FOR_LEGACYDATA_Obj?.fieldValueDescription ? MAX_DAYS_FOR_LEGACYDATA_Obj?.fieldValueDescription : Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_DAYS_FOR_LEGACYDATA_VALUE;
  //       }

  //     },
  //     error: (err) => {
  //       this.rootScope.captureLogsDb("GET-INTERACTION-CONFIG-API-FAILURE" + err, Constants.ERROR);
  //     }
  //   })
  // }

  /*******Batch ALerts related API CALLS ****/
  createBatchAlertAPI(reqBody) {
    let headers = this.getHeadersForFormDataType();

    // reqBody.append('file',this.rootScope.file)
    let url = Global.domainUrl + Global.batchAlerts.CREATE_BATCH_ALERT;
    return this.http.post(url, reqBody, {
      headers: headers,
    });
  }

/**
 * 
 * @returns Below method is used for hitting API 
 * which expects payload as form-data .
 * @author : Pooja
 * use din creating batch alert API and uopdating wrap up commeents
 */
  getHeadersForFormDataType() {
    return   new HttpHeaders()
    .append(
      'awcpusertoken',
      this.rootScope.sessionId
    )
    .set('Accept', 'application/json')
    .append('version', Constants.apiVersions)
  }

  /**
   * Get CIM_DATA config
   * update cimdata configration in local service varible
   * error is for handling api failure 
   */
  // getCIM_DATAConfig() {
  //   this.getDataByCommonKeyValueApi(Constants.CIM_DATA_ATTRIBUTE_MAPPING).subscribe({
  //     next: (res: any) => {

  //       if (res.data) {
  //         this.rootScope.cimData_config = res.data.body;
  //       }
  //     },
  //     error: (err) => {
  //       this.rootScope.unknownCallerTypeAPIFailure = true;
  //       this.rootScope.captureLogsDb("GET-CIM_DATA_ATTRIBUTE_MAPPING-API-FAILURE" + err, Constants.ERROR);
  //     }
  //   })
  // }


  /**
  * Get Config_DesktopIndicator
  * update Config_DesktopIndicator configration in local service varible
  * @author Hashid
  * CCR3-7924
  */
  // getDuelDeskTopIndicator() {
  //   this.getDataByCommonKeyValueApi(Constants.SCREEN_POP_DESKTOP_INDICATOR).subscribe({
  //      /* istanbul ignore next */
  //     next: (res: any) => {
  //       if (res.data) {
  //         // this.rootScope.duelDesk_indicator = res.data.body;
  //         this.rootScope.duelDesk_indicator = res?.data?.body.map(item => item.fieldValueDescription);
  //       }
  //     },
  //     error: (err) => {
  //       this.rootScope.captureLogsDb("GET-Config_DesktopIndicator" + err, Constants.ERROR);
  //     }
  //   })
  // }

  getCurrentBatchAlertsData(clientId){
    let url = Global.domainUrl + Global.batchAlerts.CREATE_BATCH_ALERT;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        clientId: clientId,
      }
    }); 
   
  }
  getArchivedBatchAlertsData(clientId){
    let url = Global.domainUrl + Global.batchAlerts.ARCHIVED_BATCH_ALERT;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        clientId: clientId,
      }
    }); 

  }
  
  getViewParticipantBatchAlert(BatchId,RecordCount,skipCount){
    let url = Global.domainUrl + Global.batchAlerts.VIEW_PARTICIPANT_BATCH_ALERT;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        batchId: BatchId,
        skipCount: skipCount,
        recordCount: RecordCount
        
      }
    }); 

  }

  getPreAuthConfig(clientId) {
    let url = Global.domainUrl + Global.GET_PRE_AUTH_CONFIG;
    let reqBody = {
      clientId: clientId
    }
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  getPreAuthUserData(clientId, customerSessionId) {
    let url = Global.domainUrl + Global.GET_PRE_AUTH_IDENTIFY_USER;
    let reqBody = {
      clientId: clientId
    }
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, customerSessionId),
    });
  }


  getAddress(clientId, customerSessionId) {
    let url = Global.domainUrl + Global.PIN_RESET_COMMUNICATION;
    let reqBody = {
      deliveryMethod:"postal", clientId: "00095"
    }
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, customerSessionId),
    });
  }

 /**
   * Below method is used to delete the batch alert from Current Batch Alert of Administration TAB
   * @param batchAlertId 
   * @returns Observable Subscribe in Batch Alert Service
   */
 deleteBatchAlert(batchAlertId) {
  let url = `${Global.domainUrl}${Global.batchAlerts.DELETE_BATCH_ALERT}/${batchAlertId}`;
  return this.http.delete(url, {
    headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
  });
}


/**
   * Below method is used to get the deleted batch alerts 
   * CCR1-5852
   * @param clientId 
   * @returns Observable Subscribe in Batch Alert Service
   */
getDeletedBatchAlertsData(clientId){
  const url = `${Global.domainUrl}${Global.batchAlerts.DELETE_BATCH_ALERT}`;
  return this.http.get(url, {
    headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    params: {
      clientId: clientId,
      mode: 'deleted'
    }
  }); 

}

  /**
     * Below method is used to get email config for the On-Demand email
     * CCR1-6569
     * @param clientId 
     * @returns Observable Subscribe in Batch Alert Service
     */
  getOnDemandEmailConfigData(clientId) {
    const url = `${Global.domainUrl}${Global.onDemandEmail.LOAD_EMAIL_CONFIG}`;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: clientId,
      }
    });

  }

  sendEmail(reqbody) {
    const url = `${Global.domainUrl}${Global.onDemandEmail.SEND_EMAIL}`;
    return this.http.post(url,reqbody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });

  }

  getOTCConfig(clientId) {
    let url = Global.domainUrl + Global.authenticationApis.loadOTCConfig;
    let reqBody = {
      clientId: clientId
    }
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: clientId,
      }
    });
  }



  saveUpdatedWrapupComments(reqBody){

    let headers = this.getHeadersForFormDataType();
    let url = Global.domainUrl + Global.UPDATE_WRAPUP_COMMENTS;
    return this.http.put(url, reqBody, {
      headers: headers,
    });
  }

    /**
     * Below method is used to generate OTC from S-Auth API
     * CCR1-7261
     * @returns Observable Subscribe in OTC Service
     */
  generateOTC(params) {
    let url = Global.domainUrl + Global.authenticationApis.generateOTC;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: params
    });
  }

    /**
     * Below method is used to validate OTC from S-Auth API
     * CCR1-7260
     * @returns Observable Subscribe in OTC Service
     */
  validateOTC(clientId, otc) {
    let url = Global.domainUrl + Global.authenticationApis.validateOTC;
    let payload = {
      clientId: clientId,
      otc: otc
    }
    return this.http.post(url, payload, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId)
    });
  }

  getValRelockApi(sessionId) {
    let url = Global.domainUrl + Global.VAL_RELOCK_API;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, sessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId
      }
    });
  }

  /**CCR1-10309 */
  getViewJsonData(){
    let url = Global.domainUrl + Global.VIEW_UDPDATA_JSON_API;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        globalIdentifierId : this.rootScope.activeCustTab.id
      }
    });
  }

 
  
  // CCR1-11727 View Notelog From Imaging
  /**
 * Fetches Imaging Notelog by Document ID
 * @param documentId - Imaging document ID
 * @param globalIdentifierId - Global Identifier
 * @param clientId - Client ID
 * @returns Observable with notelog data
 */
  getImagingNoteLogByDocumentId(documentId, globalIdentifierId, clientId) {
  let url = Global.domainUrl + Global.GET_IMAGING_NOTELOG;
  const headers = this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId);
  const params = {
    documentId,
    globalIdentifierId,
    clientId
  };
  return this.http.get(url, { headers, params });
}

getBuildDetails() {
    /* istanbul ignore next */
    this.http
      .get(Global.domainUrl + Global.backendDetailsAPI.getBuildDetail, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .append('version', Constants.apiVersions)
          .append('awcpusertoken', this.rootScope.sessionId),
        responseType: 'text',
      })
      .subscribe({
        next: (data) => {
          if (data) {
            this.logService.log('Backend Application Build Details');
            this.logService.log(data);
          }
        },
        error: (error) => {
          if (error) {
            this.logService.infoLogs('Unauthorized access while fetching build details', this.fileName);
          }
        }
      });
    /* To print angular app build time */
    this.logService.log('Angular application Build Details');
    this.logService.log('Application Build Time :' + buildInfo.timestamp);
    this.logService.log('Build version :' + buildInfo.version);
    this.logService.log('Git Branch :' + buildInfo.git.branch);
    this.logService.log('Git User :' + buildInfo.git.user);
  }
// CCR1-11945 Update Notelog to Imaging
saveNotelogbyDocumentId(documentId, globalIdentifierId, clientId, reqBody) {
    let url = Global.domainUrl + Global.SAVE_IMAGING_NOTELOG;
    const headers = this.rootScope.getCommonHeaders(Constants.apiVersions);
    const params = {
      documentId,
      globalIdentifierId,
      clientId
    };
    return this.http.put(url, reqBody, { headers, params });
  }


}
